import {
  PARTNER_CHANGE_PASSWORD_SUCCESS,
  PARTNER_CHANGE_PASSWORD_FAILED,
  RESET_PARTNER_CHANGE_PASSWORD,
  LOADING_PARTNER_CHANGE_PASSWORD,
  NETWORK_ERROR_PARTNER_CHANGE_PASSWORD,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_PARTNER_CHANGE_PASSWORD:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case PARTNER_CHANGE_PASSWORD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case PARTNER_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_PARTNER_CHANGE_PASSWORD:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_PARTNER_CHANGE_PASSWORD:
      return (state = initialState);
    default:
      return state;
  }
};
